import { http, HttpResponse, PathParams, delay } from 'msw';
import { AuthApiPaths } from '../../../slices/auth-api.slice';
import { contacts } from '../../data/contacts';
import { authenticator } from '../../data/authenticator';
import { apiUrl } from '../apiUrl';
import { validateCurrentPassword, composeServerError, otpHandler, validateOtp } from './shared';
import { email } from '../../data/preAuthUser';

const mfaEmailVerifyMutation = http.post(apiUrl(AuthApiPaths.mfaEmailVerify), () => HttpResponse.json({}));
const mfaEmailInitMutation = http.post(apiUrl(AuthApiPaths.mfaEmailInit), () => HttpResponse.json({}));
const trustedDeviceMutation = http.post(apiUrl(AuthApiPaths.trustedDevice), () => HttpResponse.json({}));
const initEmailLoginMutation = http.post(apiUrl(AuthApiPaths.initEmailLogin), async () => {
    await delay(100); // Add delay to simulate realistic API response time for testing
    return HttpResponse.json(email);
});

const loginPassword = http.post<PathParams, { password: string }>(
    apiUrl(AuthApiPaths.loginPassword),
    async ({ request }) => {
        const { password } = await request.json();
        const error = validateCurrentPassword(password);
        return error ? composeServerError(request, error) : HttpResponse.json({ contacts, authenticatorEnabled: true });
    }
);

const loginTotp = http.post<PathParams, { passcode: string }>(
    apiUrl(AuthApiPaths.verifyLoginTotp),
    async ({ request }) => {
        const body = await request.json();
        const appId = sessionStorage.getItem('appId') || undefined;
        const isTrusted = sessionStorage.getItem('isTrusted') === 'true' || false;
        const rsBody = appId ? { isTrusted, appId } : { isTrusted };
        const error = validateOtp(body.passcode);
        return error ? composeServerError(request, error) : HttpResponse.json(rsBody);
    }
);

const resendOtp = http.post(apiUrl(AuthApiPaths.resendPhoneOtp), () => HttpResponse.json({}));
const verifyNewAuthenticator = http.post(apiUrl(AuthApiPaths.verifyNewAuthenticator), otpHandler);
const registerNewAuthenticatorMutation = http.post(apiUrl(AuthApiPaths.registerNewAuthenticator), () =>
    HttpResponse.json(authenticator)
);

export const authHandlers = [
    loginPassword,
    loginTotp,
    initEmailLoginMutation,
    trustedDeviceMutation,
    mfaEmailInitMutation,
    mfaEmailVerifyMutation,
    registerNewAuthenticatorMutation,
    verifyNewAuthenticator,
    resendOtp
];
